.scroll-container {
    max-height: 296px;
    overflow-y: auto;
    margin-top: -8px;
}
